// extracted by mini-css-extract-plugin
export default {"emptyFavorite":"WishlistIcon_emptyFavorite__2o4g8","filledFavorite":"WishlistIcon_filledFavorite__mNsC5"};